import React from "react";

const QuranVerseLines = ({
  lines,
  loadedPages,
  loadedFontFamilies,
  uthmanicFont,
  recitationSessionActive,
  recitationCurrentVerseKey,
  searchHighlightedVerseKey,
  interactive = true,
  onVersePointerDown,
  onVersePointerUp,
  onVersePointerCancel,
  showSurahBasmala = false,
  fatihaBasmalaLines = [],
}) => {
  const renderQuranLine = (line, lineIndex, isInteractive = true) => (
    <div className="quran-line" key={`line-${line.lineNumber || lineIndex}`}>
      {line.words.map((word) => {
        const pageNumber = Number(word.pageNumber);
        const family = `p${pageNumber}-v2`;
        const useGlyph = loadedPages.has(pageNumber) || loadedFontFamilies.has(family);

        return (
          <span
            key={`${word.verseKey}-${word.position}-${word.id}`}
            data-verse-key={word.verseKey}
            style={{ fontFamily: useGlyph && word.codeV2 ? family : uthmanicFont }}
            dangerouslySetInnerHTML={{ __html: useGlyph ? word.codeV2 : word.textQpcHafs }}
            className={`quran-word ${word.charTypeName === "end" ? "quran-end-marker" : ""} ${
              recitationSessionActive && word.verseKey === recitationCurrentVerseKey
                ? "quran-word--reciting"
                : ""
            } ${
              searchHighlightedVerseKey && word.verseKey === searchHighlightedVerseKey
                ? "quran-word--search-highlight"
                : ""
            } ${isInteractive ? "" : "quran-word--static"}`}
            onPointerDown={isInteractive ? (event) => onVersePointerDown(event, word.verseKey) : undefined}
            onPointerUp={isInteractive ? (event) => onVersePointerUp(event, word.verseKey) : undefined}
            onPointerCancel={isInteractive ? onVersePointerCancel : undefined}
            onPointerLeave={isInteractive ? onVersePointerCancel : undefined}
            onClick={isInteractive ? (event) => event.stopPropagation() : undefined}
          />
        );
      })}
    </div>
  );

  const renderBasmala = () => {
    if (fatihaBasmalaLines.length) {
      return fatihaBasmalaLines.map((line, lineIndex) => renderQuranLine(line, lineIndex, false));
    }

    return (
      <div className="quran-basmala-wrap" dir="rtl" aria-label="Basmala">
        <div className="quran-basmala-text">بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ</div>
      </div>
    );
  };

  return (
    <>
      {showSurahBasmala ? renderBasmala() : null}
      {lines.map((line, lineIndex) => renderQuranLine(line, lineIndex, interactive))}
    </>
  );
};

export default QuranVerseLines;